module.exports = __webpack_public_path__ + "img/STCBrand.50e01ce1.svg";